
import { defineComponent, reactive, ref, Ref } from "vue";
import { Field, Form, ErrorMessage } from "vee-validate";
import { useI18n } from "vue-i18n";

import InputText from "@/components/primevueCustom/InputText.vue";
import Button from "primevue/button";
import Checkbox from "primevue/checkbox";

import { AuthActionTypes } from "@/store/modules/auth/actions";
import { AuthMutationTypes } from "@/store/modules/auth/mutations";

import { useStore } from "@/store";
import router from "@/router";

import { IAlert, RouterName } from "@/models/common";
import { messageType } from "@/models/message";
import Specifications from "@/components/common/Specifications.vue";
import ViewProgressSpinner from "@/components/common/ViewProgressSpinner.vue";
import SelectLanguage from "@/components/common/SelectLanguage.vue";

export default defineComponent({
  name: "Signin",
  setup() {
    const store = useStore();
    const value = reactive({
      username: "",
      password: "",
    });

    const { t } = useI18n({ useScope: "global" });
    const { t: l } = useI18n();

    const alert: Ref<IAlert> = ref({
      type: messageType.ERROR,
      content: "",
    });

    const isRemember = ref(false);

    const isFetching = ref(false);

    return { value, store, alert, t, l, RouterName, isRemember, isFetching };
  },

  methods: {
    async login() {
      try {
        this.store.commit(AuthMutationTypes.SET_TOKEN, "");

        this.isFetching = true;
        const res = await this.store.dispatch(AuthActionTypes.GET_TOKEN, {
          email: this.value.username,
          password: this.value.password,
          rememberMe: this.isRemember,
        });
        this.isFetching = false;

        if (res) {
          console.log(res, "login.res");
          this.alert = {
            title: this.t("login failed"),
            content: this.t(res),
            type: messageType.ERROR,
          };
        } else {
          console.log(res, "login.GET_ACCOUNT_INFO");
          const accountInfo = await this.store.dispatch(AuthActionTypes.GET_ACCOUNT_INFO);
          console.log(accountInfo, "accountInfo");

          const redirect = router.currentRoute.value.query?.redirect?.toString() ?? "/";

          router.push({ path: redirect });
        }
      } catch (error) {
        this.isFetching = false;
        this.alert = {
          title: this.t("login failed"),
          content: this.t(error),
          type: messageType.ERROR,
        };

        console.error("AuthActionTypes.GET_TOKEN", error);
      }
    },
  },
  components: {
    InputText,
    Button,
    Field,
    Form,
    ErrorMessage,
    Specifications,
    Checkbox,
    ViewProgressSpinner,
    SelectLanguage,
  },
});
